<template>
  <v-app id="app">
    <NavBar :menu="menu" />
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import NavBar from './components/NavBar';

export default {
  components: {
    NavBar,
  },
  data: () => ({
    name: 'App',
    menu: [
      {
        icon: 'mdi-account',
        text: 'User',
        active: false,
        subItems: [
          {
            icon: 'mdi-lock',
            text: 'Change Password',
            route: '/user/changepassword',
          },
          {
            icon: 'mdi-email',
            text: 'Change E-mail',
            route: '/user/changeemail',
          },
          {
            icon: 'mdi-account-edit',
            text: 'Edit User',
            route: '/user/edituser',
          },
        ],
      },
      {
        icon: 'mdi-usb-flash-drive',
        text: 'Software releases',
        active: false,
        subItems: [
          {
            icon: 'mdi-group',
            text: 'Release bundles',
            route: '/releasebundles',
          },
          {
            icon: 'mdi-fire',
            text: 'Release Files',
            route: '/releasefiles',
          },
          {
            icon: 'mdi-gift',
            text: 'Upgrade Package Templates',
            route: '/upgradepackagetemplates',
          },
        ],
      },
      {
        icon: 'mdi-bullseye',
        text: 'Target Definitions',
        active: false,
        subItems: [
          {
            icon: 'mdi-bullseye',
            text: 'Target Scoring Definitions',
            route: '/targetscoringdefinitions',
          },
          {
            icon: 'mdi-bullseye-arrow',
            text: 'Physical Target Definitions',
            route: '/physicaltargetdefinitions',
          },
        ],
      },
      {
        icon: 'mdi-clipboard-list',
        text: 'Shooting Program Templates',
        active: false,
        subItems: [
          {
            icon: 'mdi-clipboard-list',
            text: 'Shooting Program Templates',
            route: '/shootingprogramtemplates',
          },
          {
            icon: 'mdi-music-note-outline',
            text: 'Audio files',
            route: '/audiofiles',
          },
          {
            icon: 'mdi-file-music-outline',
            text: 'Audio collections',
            route: '/audiocollections',
          },
          {
            icon: 'mdi-bookmark-box-outline',
            text: 'Media files',
            route: '/mediafiles',
          },
          {
            icon: 'mdi-bookmark-box-multiple-outline',
            text: 'Media collections',
            route: '/mediacollections',
          },
        ],
      },
      {
        icon: 'mdi-view-dashboard',
        text: 'Organizations and clubs',
        active: false,
        subItems: [
          {
            icon: 'mdi-view-agenda',
            text: 'Organizations',
            route: '/organizations',
          },
          {
            icon: 'mdi-view-grid',
            text: 'Club groups',
            route: '/clubGroups',
          },
          {
            icon: 'mdi-view-grid',
            text: 'Clubs',
            route: '/clubs',
          },
        ],
      },
      {
        icon: 'mdi-key',
        text: 'Licenses',
        active: false,
        subItems: [
          {
            icon: 'mdi-key-link',
            text: 'Production licenses',
            route: '/license/production',
          },
          {
            icon: 'mdi-cloud-key-outline',
            text: 'API keys',
            route: '/license/apikeys',
          },
        ],
      },
      {
        icon: 'mdi-account-cog',
        text: 'Owner management',
        active: false,
        subItems: [
          {
            icon: 'mdi-account',
            text: 'Manage owners',
            route: '/ownerManagement',
          },
          {
            icon: 'mdi-folder-marker',
            text: 'Manage arenas & ranges',
            route: '/arenas',
          },
          {
            icon: 'mdi-account-off',
            text: 'Unregistered eHubs',
            route: '/unRegisteredeHubs',
          },
        ],
      },
      {
        icon: 'mdi-account-group',
        text: 'User management',
        active: false,
        subItems: [
          {
            icon: 'mdi-account-multiple',
            text: 'Users',
            route: '/users',
          },
        ],
      },
    ],
  }),
};
</script>
